import axios from "axios";
import { v4 as uuidv4 } from "uuid";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "/api",
  withCredentials: true,
  timeout: 10000, // 10 seconds timeout
});

// ===== CREATE IDS IF NOT EXIST =====
let guestId = localStorage.getItem("grgpt_guest_id");
let deviceId = localStorage.getItem("grgpt_device_id");

if (!guestId) {
  guestId = uuidv4();
  localStorage.setItem("grgpt_guest_id", guestId);
}

if (!deviceId) {
  deviceId = uuidv4();
  localStorage.setItem("grgpt_device_id", deviceId);
}

// ================= REQUEST INTERCEPTOR =================
API.interceptors.request.use((config) => {
  // ✅ Read token fresh on every request (not once at module load)
  const token = localStorage.getItem("grgpt_token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  config.headers["x-guest-id"] = guestId;
  config.headers["x-device-id"] = deviceId;

  return config;
});

// ================= RESPONSE INTERCEPTOR =================
API.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url;

    // ✅ Return null data so .then() is skipped cleanly
    if (status === 401 && url?.includes("/auth/me")) {
      return Promise.resolve({ data: null });
    }

    return Promise.reject(error);
  }
);

export default API;